import { Anchor } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { Id } from '@feature/utils';

export interface ConferenceLinkProps {
  conferenceId: Id;
  title: string;
}

export function ConferenceLink(props: ConferenceLinkProps) {
  const { conferenceId, title } = props;
  return (
    <Anchor
      fw="500"
      c="text"
      component={Link}
      to={`/conference/${conferenceId}`}
    >
      {title}
    </Anchor>
  );
}
